import AppBar from '../components/AppBar/AppBar';

const MainNav = () => {
  return <AppBar />;
};

export default MainNav;
